"use client";
import * as React from "react";
import { cn } from "@repo/utils/utils";
const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (<div ref={ref} className={cn("relative h-2 w-full overflow-hidden rounded-full bg-gray-200", className)} {...props}>
      <div className="h-full w-full flex-1 bg-blue-600 transition-all duration-300 ease-in-out" style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}/>
    </div>));
Progress.displayName = "Progress";
export { Progress };
